import types from '../types/reservation'
import {Map} from 'immutable'

const initialRoot = Map({
  startDate: null,
  endDate: null,
  isLoading: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_RANGE:
      return state.merge(setRange(action.payload.start, action.payload.end))
    case types.SAVE_ADD_ITEM:
      return state.merge(asyncStart())
    case types.SAVE_ADD_ITEM_SUCCESS:
      return state.merge(asyncSuccess())
    case types.SAVE_ADD_ITEM_FAIL:
      return state.merge(asyncFail(action.payload.error))
    default:
      return state
  }
}

function setRange(start, end) {
  return {
    startDate: start,
    endDate: end,
  }
}

function asyncStart() {
  return {
    isLoading: true,
    error: '',
  }
}

function asyncSuccess() {
  return {
    isLoading: false,
    error: '',
  }
}

function asyncFail(error) {
  return {
    isLoading: false,
    error,
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/rent/reducers/reservation.js